import { setContext } from "@apollo/client/link/context";

export default () =>
  setContext((_, { headers }) => {
    const headersToReturn = {
      ...headers,
      "x-timezone": Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    return {
      headers: headersToReturn
    };
  });
